import { consumeNDJSONStream } from "./streamParser";

export function buildAssistantFormData(payload) {
  const formData = new FormData();

  formData.append("message", payload.message);
  formData.append("conversationId", payload.conversationId);
  formData.append("history", JSON.stringify(payload.history));
  formData.append("viewContext", JSON.stringify(payload.viewContext));
  formData.append("clientContext", JSON.stringify(payload.clientContext));
  formData.append("imageContext", JSON.stringify(payload.imageContext));
  formData.append("visibleDigest", JSON.stringify(payload.visibleDigest || {}));
  if (payload.scappContext) {
    formData.append("scappContext", JSON.stringify(payload.scappContext));
  }
  if (payload.nanooxContext) {
    formData.append("nanooxContext", JSON.stringify(payload.nanooxContext));
  }

  if (payload.screenshot?.blob) {
    const fileName = payload.screenshot.fileName || "current-view.png";
    const mimeType =
      payload.screenshot.mimeType ||
      payload.screenshot.blob.type ||
      "application/octet-stream";
    const screenshotFile =
      typeof File !== "undefined"
        ? new File([payload.screenshot.blob], fileName, { type: mimeType })
        : payload.screenshot.blob;

    formData.append(
      "screenshot",
      screenshotFile,
      fileName
    );
  }

  return formData;
}

export async function streamAssistantResponse({
  endpoint,
  payload,
  signal,
  onEvent,
}) {
  const response = await fetch(endpoint, {
    method: "POST",
    body: buildAssistantFormData(payload),
    signal,
    headers: {
      Accept: "application/x-ndjson, application/json, text/plain",
    },
  });

  if (!response.ok) {
    const errorText = await response.text().catch(() => "");
    throw new Error(errorText || `Request failed with status ${response.status}`);
  }

  if (!response.body) {
    const text = await response.text();
    text
      .split(/\r?\n/)
      .map((line) => line.trim())
      .filter(Boolean)
      .forEach((line) => onEvent(JSON.parse(line)));
    return;
  }

  await consumeNDJSONStream(response.body, {
    onEvent,
    onParseError: (error, chunk) => {
      throw new Error(`Invalid streaming payload: ${error.message} :: ${chunk}`);
    },
  });
}
